import React from 'react';

// ponytail: mongo subdoc _id embeds its creation time, so "marked at" needs no extra field
const markedAt = (id) => {
    if (!id || id.length < 8) return null;
    return new Date(parseInt(id.substring(0, 8), 16) * 1000);
};

const MealInfoModal = ({ isOpen, onClose, title, data }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 transition-opacity">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden animate-fade-in-up">
                <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200">
                    <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div className="p-4 max-h-96 overflow-y-auto">
                    {data && data.length > 0 ? (
                        <ul className="space-y-3">
                            {data.map((item, index) => (
                                <li key={index} className="flex justify-between items-center bg-gray-50 p-3 rounded border border-gray-100">
                                    <div>
                                        <div className="font-medium text-gray-700">{item.day}</div>
                                        {markedAt(item._id) && (
                                            <div className="text-[11px] text-gray-400">Marked {markedAt(item._id).toLocaleString()}</div>
                                        )}
                                    </div>
                                    <div className="text-sm text-gray-500">{new Date(item.date).toLocaleDateString()}</div>
                                    <div className="text-sm font-semibold text-blue-600 bg-blue-50 px-2 py-1 rounded">{item.period}</div>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div className="text-center text-gray-500 py-8">No records found.</div>
                    )}
                </div>
                <div className="px-4 py-3 border-t border-gray-200 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded font-medium transition"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MealInfoModal;
